var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'd-none': _vm.hidden },staticStyle:{"width":"90%","margin":"30px","height":"500px"},attrs:{"id":"talkjs-container"}},[_vm._v(" Loading chat... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }